import _ from 'lodash';

export function getBaseUrl(): string {
  // example: https://test-app.thehost.com
  return window.location.origin;
}

export function getSubdomainUrl(subdomain: string): string {
  return `https://${subdomain}.thehost.co`;
}

interface getStoreLinkProps {
  isEnabled: boolean;
  subdomain: string;
  isSubdomainEnabled: boolean;
  storeId: number;
}

export const getStoreLink = ({
  isEnabled,
  subdomain,
  isSubdomainEnabled,
  storeId,
}: getStoreLinkProps): string => {
  if (!isEnabled || !subdomain || !isSubdomainEnabled) {
    return `${getBaseUrl()}/store/${storeId}/`;
  }
  return `${getSubdomainUrl(subdomain)}/store/${storeId}/`;
};

interface getStoreiframeProps {
  storeLink: string;
}

export const getIframeSnippet = ({ storeLink }: getStoreiframeProps): string => {
  return `<iframe src="${storeLink}" width="100%" height="800"frameborder="0" allowfullscreen></iframe>`;
};

export const convertPxToRem = ({ px: number }): string => {
  return `${number / 16}rem`;
};

/**
 * Call this function as a placeholder whenever there's a point in the code that should not be reached.
 *
 * The Type is set to () => void so it doesn't clash with overriding implementations
 *
 * Example usage: when defining the types for a Context provider.
 *
 */
export const notImplementedError = (): void => {
  throw new Error('Not Implemented.');
};

export const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
  navigator.userAgent,
);

export const stringConvertToBoolean = ({ value }: { value: string | boolean }) =>
  value === true ||
  (_.isString(value) && value.toLowerCase() === 'true') ||
  (_.isString(value) && value.toLowerCase() === 'yes') ||
  value === '1';

type Value = string | number | null | boolean;

const formatParam = (value: Value | Value[], key: string) => {
  if (_.isArray(value)) {
    return value.map((val) => `${key}=${val}`).join('&');
  }
  return `${key}=${value}`;
};

export const formatGetParams = (params: { [key: string]: Value | Value[] }) => {
  const urlParams = _.map(params, formatParam).join('&');
  return `${_.isEmpty(params) ? '' : '?'}${urlParams}`;
};

export const downloadFile = (url: string, filename: string) => {
  const link = window.document.createElement('a');
  link.setAttribute('href', url);
  link.setAttribute('download', filename);
  window.document.body.appendChild(link);
  link.click();
};

export const addQueryParams = ({
  url,
  queryParams,
}: {
  url: string;
  queryParams: { [key: string]: string };
}) => {
  const questionMarkSeparator = url.indexOf('?') < 0 ? '?' : '&';
  const formattedQueryParams = new URLSearchParams(queryParams);
  return `${url}${questionMarkSeparator}${formattedQueryParams.toString()}`;
};

/**
 * Scroll the page to the top with smooth behavior.
 */
export const scrollToTop = (): void => {
  window.scroll({ top: 0, behavior: 'smooth' });
};

/**
 *
 * Scroll the page to the selected anchor with smooth behavior.
 */
export const scrollToSelectedAnchor = ({ anchor }: { anchor: string }): void => {
  const el = window.document.getElementById(anchor);

  if (el) {
    window.scroll({ top: el.offsetTop, behavior: 'smooth' });
  }
};
